import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-providers-approval',
  templateUrl: './providers-approval.component.html',
  styleUrls: ['./providers-approval.component.scss']
})
export class ProvidersApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
